import Api from "@/api"
import { useLoading } from "@/composition/useLoading"
import type { Id, VtsLog } from "@/models"
import { watchImmediate } from "@vueuse/core"
import { computed, reactive, ref, shallowRef } from "vue"

export function useEditingVtsLog() {
	const { runAction } = useLoading()

	const editingLogId = ref<Id | null>(null)
	const editingLog = shallowRef<VtsLog | null>(null)

	async function loadLog(id: Id) {
		try {
			const log = await Api.vts.getById(id)
			if (log != null) editingLog.value = reactive(log) as VtsLog
		} catch (e) {
			closeLogPopup()
		}
	}

	function openLog(id: Id) {
		editingLogId.value = id
	}

	function closeLogPopup() {
		editingLogId.value = null
		editingLog.value = null
	}

	watchImmediate(editingLogId, (logId) => {
		if (!editingLogId.value) {
			editingLog.value = null
		} else {
			void runAction(loadLog(logId!))
		}
	})

	return {
		editingLogId,
		openLog,
		closeLogPopup,
		editingLog: computed<VtsLog | null>(() => editingLog.value),
	}
}
